import MainNavigationBarComponent from '../components/MainNavigationBar';
import Footer from '../components/Footer';
import Box from 'carbon-react/esm/components/box';
import { LayoutProps } from './types/layout.types';
import { PrivateMainErrorBoundary } from './ErrorBoundary/PrivateMainErrorBoundary';

export const PrivateMainLayout = ({ children, withErrorBoundary }: LayoutProps) => {
  const content = withErrorBoundary ? (
    <PrivateMainErrorBoundary errorLayout="PrivateMainLayout">{children}</PrivateMainErrorBoundary>
  ) : (
    children
  );

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <MainNavigationBarComponent />
      <Box display="flex" flex="1" flexDirection="column">
        {content}
      </Box>
      <Footer />
    </Box>
  );
};
